/*
 * Main and demo navigation arrays
 */

export default {
  main: [
    {
      name: "Dashboard",
      to: "/",
      icon: "si si-speedometer"
    },
    {
      name: "Report",
      to: "/report",
      icon: "fa fa-file-contract"
    },
    {
      name: "Vergleichsgruppen",
      to: "/comparison_groups",
      icon: "si si-compass"
    },
    {
      name: "Verwaltung",
      to: "/admin",
      icon: "si si-settings",
      sub: [
        {
          name: "Vergleichsgruppen",
          to: "/admin/comparison_groups"
        },
        {
          name: "Keywords",
          to: "/admin/keywords"
        },
        {
          name: "Artikel",
          to: "/admin/items"
        },
        {
          name: "Benutzer",
          to: "/admin/users"
        }
      ]
    }
  ]
};
